import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TrainingPresenter, getSlides } from '../features/training';
import { trackEvent } from '../shared';

/**
 * TrainingPage - Cybersecurity awareness training
 */
function TrainingPage() {
  const { i18n } = useTranslation();
  const slides = getSlides('cybersecurity', i18n.language);

  useEffect(() => {
    trackEvent('training_started', {
      module: 'cybersecurity',
      language: i18n.language,
      slideCount: slides.length,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <TrainingPresenter slides={slides} moduleName="cybersecurity" />;
}

export default TrainingPage;
